export default __webpack_public_path__ + "static/media/bg-2.0c6aef42.jpg";